import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/app/tools/elevator-pitch-generator/ElevatorPitchContent.tsx");
